export const Events = [
  {
    path: '/events/:app_module_id',
    name: 'events.index',
    component: () => import('@/pages/Events/EventsModule')
  },
  {
    path: '/events/:app_module_id/event/:id',
    name: 'events.item',
    component: () => import('@/pages/Events/EventsPage')
  },
  {
    path: '/events/:app_module_id/event/:id/details/:profile_type/:profile_id',
    name: 'events.speakers',
    component: () => import('@/pages/Events/EventsProfile')
  },
  {
    path: '/events/:app_module_id/event/:id/agenda',
    name: 'events.agenda',
    component: () => import('@/pages/Events/EventsAgenda')
  },
]
